<template>
  <v-main>
    <v-container>
      <ValidationObserver ref="validationObserver">
        <v-form>
          <v-row>
            <v-col class="text-center">
              <img :src="`${aws_s3_bucket_url}assets/images/koibox.webp`" style="width: 135px;" />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <h2 class="text-center">
                {{ $t('{name}, antes de activar WhatsApp', {name: user}) }}:
              </h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <CondicionesContratacionWhatsapp />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider rules="required" :name="$t('Condiciones').toLowerCase()" v-slot="{ errors, classes }">
                <v-checkbox
                    readonly
                    v-model="i_agree"
                    @click="manage_signature"
                    hide-details
                >
                  <template v-slot:label>
                    {{$t('He leído y acepto la información facilitada sobre los términos de uso de Whatsapp en la app de gestión')}}.
                  </template>
                </v-checkbox>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8">
              <ValidationProvider rules="required" :name="$t('Razón social').toLowerCase()" v-slot="{ errors, classes }">

                <v-text-field
                    :class="classes"
                    v-model="form.razon_social"
                    :label="$t('Razón social')"
                    hide-details
                    outlined dense
                    autofocus
                >
                </v-text-field>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
            <v-col cols="4">
              <ValidationProvider rules="required" :name="$t('CIF').toLowerCase()" v-slot="{ errors, classes }">

                <v-text-field
                    :class="classes"
                    v-model="form.cif"
                    :label="$t('CIF')"
                    hide-details
                    outlined dense
                    autofocus
                >
                </v-text-field>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="5">
              <ValidationProvider rules="required" :name="$t('Dirección').toLowerCase()" v-slot="{ errors, classes }">

                <v-text-field
                    :class="classes"
                    v-model="form.direccion_social"
                    :label="$t('Dirección')"
                    hide-details
                    outlined dense
                    autofocus
                >
                </v-text-field>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
            <v-col cols="2">
              <ValidationProvider rules="required" :name="$t('C.P.').toLowerCase()" v-slot="{ errors, classes }">

                <v-text-field
                    :class="classes"
                    v-model="form.codigo_postal_social"
                    :label="$t('C.P.')"
                    hide-details
                    outlined dense
                    autofocus
                >
                </v-text-field>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
            <v-col cols="5">
              <ValidationProvider rules="required" :name="$t('Localidad').toLowerCase()" v-slot="{ errors, classes }">

                <v-text-field
                    :class="classes"
                    v-model="form.localidad_social"
                    :label="$t('Localidad')"
                    hide-details
                    outlined dense
                    autofocus
                >
                </v-text-field>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="mt-4" style="text-align: center">
              <v-btn color="primary" @click="save_firma" :disabled="!i_agree" large>
                {{ $t("Continuar") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-container>

    <DialogSignature ref="dialog_signature" @on_save_signature="set_signature" />
  </v-main>
</template>


<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CondicionesContratacionWhatsapp from "@/views/Configuracion/Centro/components/CondicionesContratacionWhatsapp.vue";
import CONSTANTS from "@/utils/constants";

export default {
  name: 'ActivarWhatsapp',
  created() {
    document.title='Activar Whatsapp'
  },
  beforeDestroy() {
    document.title='Koibox'
  },
  data(){
    return {
      CONSTANTS,
      user: this.$store.getters['auth/user'].first_name,
      aws_s3_bucket_url: process.env.VUE_APP_AWS_S3_BUCKET,
      locale: this.$i18n.locale,

      i_agree: false,
      form: null
    }
  },

  methods: {
    async save_firma(){
      const form_valid = await this.$refs.validationObserver.validate()
      if (form_valid) {
        try {
          if(!this.form.b64_firma){
            this.$snotify.error(
                this.$t("Debes aceptar y firmar los términos de uso"),
                this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
            )
            return
          }
          await this.$store.dispatch('planes_koibox/aceptar_whatsapp', this.form)
          await this.$store.dispatch('centro/get_centro')
          await this.$router.push({name: 'whatsapp'})
          return this.$snotify.success(
              this.$t('Acción realizada con éxito'),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        } catch (e) {
          return this.$snotify.error(
              e,
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }
    },

    set_signature(signature){
      this.form.b64_firma = signature
      this.i_agree = true
      this.form = {...this.form}
    },

    delete_signature(){
      this.form.b64_firma = null
      this.i_agree = null
      this.form = {...this.form}
    },

    manage_signature(){
      this.i_agree? this.delete_signature() : this.open_dialog_signature()
    },

    open_dialog_signature(){
      this.$refs.dialog_signature.open_dialog()
    },
  },

  mounted() {
    this.$store.state.centro.centro.nombre
    this.form = {
      b64_firma: null,
      razon_social: this.$store.state.centro.centro.razon_social,
      cif: this.$store.state.centro.centro.cif,
      direccion_social: this.$store.state.centro.centro.direccion_social,
      codigo_postal_social: this.$store.state.centro.centro.codigo_postal_social,
      localidad_social: this.$store.state.centro.centro.localidad_social,
    }
  },

  components: {
    CondicionesContratacionWhatsapp,
    ValidationProvider,
    ValidationObserver,
    DialogSignature: () => import('@/components/shared/DialogSignature.vue'),
  }
}
</script>

<style lang="scss" scoped>
.precio {
  font-size: 2em;
  font-weight: bold;
}
.container {
  width: 1000px !important;
}
.v-card__text{
  min-height: 430px;
}
ul {
  padding-left: 0 !important;
  li {
    list-style: none;

  }
}
</style>
